export { ChartOfAccountsView } from "../../components/accounts/chart-of-accounts-view";
